// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"db5bbf80","455":"86146db2","977":"863c936e"}[chunkId] + ".chunk.js";
};